import { mCmToFtIn, kgToLb } from "Helpers/util";
import { apiGetAnswers, apiUpdateAnswers } from "Root/api/apiProfile";
import { setGlobalLoading, setOriginalAnswers, setSelectedAnswers, setQuizOptions, changeProducts, changeProductsStatus, editModelObject, } from "../../actionCreators/makeActionCreator";
import toastService from "../../../toastService/index";
import { prepapeQuizOptionsDataObj, prepareAnswerObject, editModeDefaultObj, } from "../../../components/MyProfile/utils";
export const fetchProfileDataThunk = (showLoading = true) => async (dispatch) => {
    if (showLoading) {
        dispatch(setGlobalLoading(true));
    }
    const { data, modifiedAnswersObj } = await apiGetAnswers();
    if (showLoading) {
        dispatch(setGlobalLoading(false));
    }
    dispatch(setOriginalAnswers({ ...modifiedAnswersObj }));
    dispatch(setSelectedAnswers({ ...modifiedAnswersObj }));
    dispatch(setQuizOptions(JSON.parse(JSON.stringify(prepapeQuizOptionsDataObj(data.all_options)))));
};
export const saveProfileDataThunk = () => async (dispatch, getState) => {
    try {
        dispatch(setGlobalLoading(true));
        const myProfileState = getState().myProfile;
        const isMetrics = getState().myProfile.metrics;
        const metricsUsObj = () => {
            if (isMetrics) {
                const answersMetricsToUs = {
                    ...myProfileState.selectedAnswers,
                    ft: mCmToFtIn(myProfileState.selectedAnswers.m, myProfileState.selectedAnswers.cm)[0],
                    inch: mCmToFtIn(myProfileState.selectedAnswers.m, myProfileState.selectedAnswers.cm)[1],
                    weight: kgToLb(myProfileState.selectedAnswers.weightKG),
                    goalWeight: kgToLb(myProfileState.selectedAnswers.goalWeightKG),
                };
                delete answersMetricsToUs.cm;
                delete answersMetricsToUs.m;
                delete answersMetricsToUs.weightKG;
                delete answersMetricsToUs.goalWeightKG;
                return answersMetricsToUs;
            }
            const answersUs = { ...myProfileState.selectedAnswers };
            delete answersUs.cm;
            delete answersUs.m;
            delete answersUs.weightKG;
            delete answersUs.goalWeightKG;
            return answersUs;
        };
        if (!Object.values(prepareAnswerObject(metricsUsObj())).every((item) => !!item)) {
            dispatch(setGlobalLoading(false));
            toastService.errorMessage("Validation Error. Please fill out all fields");
            return;
        }
        const data = await apiUpdateAnswers({
            data: prepareAnswerObject(metricsUsObj()),
        });
        dispatch(editModelObject({
            ...myProfileState.editModeObj,
            basics: editModeDefaultObj.basics,
            dietaryPreferences: editModeDefaultObj.dietaryPreferences,
            dietaryRestrictions: editModeDefaultObj.dietaryRestrictions,
            exerciseHabits: editModeDefaultObj.exerciseHabits,
            nutritionGoals: editModeDefaultObj.nutritionGoals,
            performanceGoals: editModeDefaultObj.performanceGoals,
        }));
        dispatch(fetchProfileDataThunk());
        if (data.products_changed.length > 0) {
            dispatch(changeProducts(data.products_changed));
            dispatch(changeProductsStatus(true));
        }
        else {
            toastService.successMessage("Your profile has been updated. Enjoy formulas that continue to meet your specific needs.");
        }
    }
    catch (e) {
        console.log(e);
        toastService.errorMessage("Something went wrong");
    }
    finally {
        dispatch(setGlobalLoading(false));
    }
};
